import type { DyadMatrixEntry } from "@unruly-global/api-types";

/** Single source of truth for the 1–5 dyad status colour palette. */
export const DYAD_STATUS_PALETTE: Record<
  number,
  { bg: string; text: string; label: string }
> = {
  1: { bg: "#D94052", text: "#fff", label: "Hostile" },
  2: { bg: "#E8A838", text: "#1a1a1a", label: "Tense" },
  3: { bg: "#E5C642", text: "#1a1a1a", label: "Stable" },
  4: { bg: "#3EAA6D", text: "#fff", label: "Friendly" },
  5: { bg: "#1D7A4E", text: "#fff", label: "Close" },
};

/** Extract unique countries from dyad entries, in order of first appearance. */
export function extractCountries(dyads: DyadMatrixEntry[]): string[] {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const d of dyads) {
    for (const c of [d.countryA, d.countryB]) {
      if (!seen.has(c)) {
        seen.add(c);
        result.push(c);
      }
    }
  }
  return result;
}
